<template>
  <div class="page"
       tabindex="0"
       v-bind:class="{
          'page--overlay' : initialData.overlayMenu,
          'page--auth-overlay' : isActiveOverlayLogin
       }">

    <!-- -->
    <Header></Header>

    <!--  ЭКРАНЫ START -->
    <div class="page__content"
         v-bind:class="{ 'page__content__down' : initialData.overlayMenu }">
      <swiper :options="swiper.fullpageOptions" ref="MainSwiper" class="mainSwiperInitial" @ready="checkFullpageSlideTo">
        <!-- Презентация -->
        <swiper-slide class="swiper-slide mainSwiperInitial_item">
          <perfect-scrollbar ref="ps1">
            <div class="d-flex flex-column justify-content-between height-100">
              <div class="centered height-100">
                <div class="grid  height-100">
                  <div class="grid__cell-lg-20 offset-lg-2 d-flex flex-column justify-content-between">
                    <div class="slider d-md-flex flex-md-column flex-md-fill justify-content-lg-center">
                      <div class="slider-back"
                           v-if="activeOfferSlide !== 0"
                           v-on:click="activeOfferSlide = 0">
                        <img src="../assets/img/arrow-left.svg">
                      </div>
                      <div class="slider__item"
                           v-show="activeOfferSlide === 0">
                        <div class="screen screen--offer screen--offer-main d-md-flex flex-md-column justify-content-lg-center ">
                          <div class="main-illustration">
                          </div>
                          <img class="screen__illustration screen__illustration--offer-main"
                               src="../assets/img/content/car_main.jpg" />
                          <div class="grid">
                            <div class="grid__cell offset-md-3 offset-lg-0 grid__cell-lg-13">
                              <div class="screen__title">Автомобиль<br>всегда<br>под контролем</div>
                              <div class="screen__title screen__title--sm">Автомобиль<br>всегда под контролем</div>
                              <div class="screen__text screen__text--offer-main">Управляйте им онлайн через приложение</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <transition name="fade">
                        <div class="slider__item"
                             v-show="activeOfferSlide === 1">
                          <div class="screen screen--offer">
                            <img class="screen__illustration screen__illustration--offer-location" src="../assets/img/content/car_location.jpg"/>
                            <div class="grid">
                              <div class="grid__cell offset-md-3 offset-lg-0 grid__cell-lg-13">
                                <div class="screen__title">Местоположение</div>
                                <div class="screen__text">
                                  <p>Откройте страницу личного кабинета и посмотрите, где сейчас находится Ваш автомобиль, автомобиль супруги, сына или дочери.</p>
                                  <p>Беспокоитесь за своих близких? Задайте на карте интересующие «Места» и включите оповещения о том, что дочь добралась до университета, а отец приехал на дачу.</p>
                                  <p>Собираетесь к приятелю на день рождения и забыли, как удобнее проехать? Гляньте в «Поездках», как ехали в прошлом году.</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                      <transition name="fade">
                        <div class="slider__item"
                             v-show="activeOfferSlide === 2">
                          <div class="screen screen--offer">
                            <img class="screen__illustration screen__illustration--offer-security" src="../assets/img/content/car_security.jpg"/>
                            <div class="grid">
                              <div class="grid__cell offset-md-3 offset-lg-0 grid__cell-lg-13">
                                <div class="screen__title">Безопасность</div>
                                <div class="screen__text">
                                  <p>Откройте страницу личного кабинета и убедитесь, что ваш автомобиль находится под охраной и с ним все в порядке. Если вдруг вы обнаружили, что забыли поставить автомобиль на охрану — не стоит паниковать.</p>
                                  <p>При попытке проникнуть в салон, угнать или эвакуировать автомобиль, а также в случае удара по автомобилю и любой другой тревожной ситуации вы получите оперативное оповещение на мобильный телефон и сможете отреагировать немедленно.</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                      <transition name="fade">
                        <div class="slider__item"
                             v-show="activeOfferSlide === 3">
                          <div class="screen screen--offer">
                            <img class="screen__illustration screen__illustration--offer-diagnostics" src="../assets/img/content/car_diagnostics.jpg"/>
                            <div class="grid">
                              <div class="grid__cell offset-md-3 offset-lg-0 grid__cell-lg-13">
                                <div class="screen__title">Диагностика</div>
                                <div class="screen__text">
                                  <p>Телематические комплексы компании «Мега-Ф» подключаются к информационным CAN-шинам автомобиля и предоставляют Вам данные о работе двигателя и других агрегатов автомобиля в режиме онлайн.</p>
                                  <p>Вы получите информацию о состоянии автомобиля не в виде малопонятных цифр и кодов, а в формате графиков и отчетов. Данные диагностики хранятся на сервере «Мега-Ф Телематика».</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                      <transition name="fade">
                        <div class="slider__item"
                             v-show="activeOfferSlide === 4">
                          <div class="screen screen--offer">
                            <img class="screen__illustration screen__illustration--offer-comfort" src="../assets/img/content/car_comfort.jpg"/>
                            <div class="grid">
                              <div class="grid__cell offset-md-3 offset-lg-0 grid__cell-lg-13">
                                <div class="screen__title">Комфорт</div>
                                <div class="screen__text">
                                  <p>Со страниц личного кабинета вы всегда сможете:</p>
                                  <p>
                                    — посмотреть местоположение вашего автомобиля;<br>
                                    — узнать его текущее состояние (стоит автомобиль или движется, закрыты ли его двери, включены или выключены габаритные огни и др.);<br>
                                    — поставить автомобиль на охрану / снять с охраны;<br>
                                    — запустить двигатель и прогреть салон;<br>
                                    — найти автомобиль на парковке;<br>
                                    — узнать температуру в салоне, количество топлива в баке и напряжение аккумулятора.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                    <div class="list list--horizontal list--nav">
                      <div class="grid justify-content-sm-between">
                        <div class="grid__cell-12 grid__cell-sm-auto flex-lg-grow-0">
                          <div v-on:click="activeOfferSlide = 1"
                               v-bind:class="{ 'list__item--active' : activeOfferSlide === 1 }"
                               class="list__item">Местоположение</div>
                        </div>
                        <div class="grid__cell-12 grid__cell-sm-auto flex-lg-grow-0">
                          <div v-on:click="activeOfferSlide = 2"
                               v-bind:class="{ 'list__item--active' : activeOfferSlide === 2 }"
                               class="list__item">Безопасность</div>
                        </div>
                        <div class="grid__cell-12 grid__cell-sm-auto flex-lg-grow-0">
                          <div v-on:click="activeOfferSlide = 3"
                               v-bind:class="{ 'list__item--active' : activeOfferSlide === 3 }"
                               class="list__item">Диагностика</div>
                        </div>
                        <div class="grid__cell-12 grid__cell-sm-auto flex-lg-grow-0">
                          <div v-on:click="activeOfferSlide = 4"
                               v-bind:class="{ 'list__item--active' : activeOfferSlide === 4 }"
                               class="list__item">Комфорт</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </perfect-scrollbar>
        </swiper-slide>
        <!-- Возможности -->
        <swiper-slide class="swiper-slide mainSwiperInitial_item">
          <perfect-scrollbar>
            <div class="centered height-100">
              <div class="grid  height-100">
                <div class="grid__cell-lg-20 offset-lg-2">
                  <div class="screen screen--carousel  height-100 d-flex justify-content-between flex-column">
                    <div class="grid align-content-center height-100">
                      <div class="grid__cell-24"><div class="screen__title">Возможности Scher-Khan</div></div>
                      <div class="grid__cell-24 grid__cell-md-13">
                        <div class="screen__text">
                          Комплекс услуг по определению координат и маршрутов передвижения автомобиля,
                          обеспечению его безопасности, защите от угона и диагностике неисправностей двигателя.
                        </div>
                      </div>
                      <div class="grid__cell-24 grid__cell-md-9 offset-md-2">
                        <ul class="list list--horizontal text-gray">
                          <li class="list__item">Наши возможности растут с каждым годом. Следите за обновлениями.</li>
                        </ul>
                      </div>
                    </div>
                    <div class="screen__illustration screen__illustration--carousel">
                      <swiper :options="swiper.functionsOptions">
                        <swiper-slide>
                          <div class="media-object">
                            <div class="media-object__image">
                              <img class="media-object__image-back" src="../assets/img/content/lock-white.svg">
                              <img class="media-object__image-front" src="../assets/img/content/lock-green.svg">
                            </div>
                            <div class="media-object__title">Постановка, снятие с охраны</div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="media-object">
                            <div class="media-object__image">
                              <img class="media-object__image-back" src="../assets/img/content/track.svg">
                              <img class="media-object__image-front" src="../assets/img/content/track.svg">
                            </div>
                            <div class="media-object__title">Открытие, закрытие дверей и багажника</div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="media-object">
                            <div class="media-object__image">
                              <img class="media-object__image-back" src="../assets/img/content/geo-white.svg">
                              <img class="media-object__image-front" src="../assets/img/content/geo-green.svg">
                            </div>
                            <div class="media-object__title">Определение местоположения автомобиля</div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="media-object">
                            <div class="media-object__image">
                              <img class="media-object__image-back" src="../assets/img/content/start-white.svg">
                              <img class="media-object__image-front" src="../assets/img/content/start-green.svg">
                            </div>
                            <div class="media-object__title">Дистанционный запуск и остановка двигателя</div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="media-object">
                            <div class="media-object__image">
                              <img class="media-object__image-back" src="../assets/img/content/status-white.svg">
                              <img class="media-object__image-front" src="../assets/img/content/status-green.svg">
                            </div>
                            <div class="media-object__title">Наглядная индикация статусов автомобиля</div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="media-object">
                            <div class="media-object__image">
                              <img class="media-object__image-back" src="../assets/img/content/eng-hot-white.svg">
                              <img class="media-object__image-front" src="../assets/img/content/eng-hot-green.svg">
                            </div>
                            <div class="media-object__title">Управление подогревом двигателя и автозапуском</div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="media-object">
                            <div class="media-object__image">
                              <img class="media-object__image-back" src="../assets/img/content/sound-white.svg">
                              <img class="media-object__image-front" src="../assets/img/content/sound-green.svg">
                            </div>
                            <div class="media-object__title">Поиск автомобиля на парковке</div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                          <div class="media-object">
                            <div class="media-object__image">
                              <img class="media-object__image-back" src="../assets/img/content/eng-stop-green.svg">
                              <img class="media-object__image-front" src="../assets/img/content/eng-stop-green.svg">
                            </div>
                            <div class="media-object__title">Блокировка двигателя, режим «Защита от захвата»</div>
                          </div>
                        </swiper-slide>
                        <swiper-slide>
                        </swiper-slide>
                        <div class="swiper-scrollbar" slot="scrollbar"></div>
                      </swiper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </perfect-scrollbar>
        </swiper-slide>
        <!-- Мобильные приложения -->
        <swiper-slide class="swiper-slide mainSwiperInitial_item">
          <perfect-scrollbar>
            <div class="d-flex flex-column height-100 justify-content-between">
              <div class="centered flex-fill">
                <div class="grid height-100">
                  <div class="grid__cell-lg-20 offset-lg-2">
                    <div class="screen screen--car-phone d-flex flex-column height-100 justify-content-center">
                      <div class="screen__title">Приложение Scher-Khan Auto</div>
                      <div class="grid">
                        <img class="screen__illustration screen__illustration--car-phone" src="../assets/img/content/car_phone.png"/>
                        <div class="grid__cell-24 grid__cell-md-18 grid__cell-lg-13">
                          <div class="screen__text">
                            Управляйте вашей безопасностью из любой точки мира благодаря Scher-Khan Auto.
                            Передовые технологии GSM+GPRS. GPS+ГЛОНАСС на страже вашего спокойствия.
                          </div>
                          <ul class="list list--horizontal text-gray">
                            <li class="list__item">Надежность. Комфорт. Безопасность.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-color-green-gradient">
                <div class="centered">
                  <div class="grid">
                    <div class="grid__cell-lg-20 offset-lg-2">
                      <div class="screen screen--apps">
                        <img class="screen__illustration screen__illustration--car-device" src="../assets/img/content/car_device.png"/>
                        <!--<div class="screen__text">Мобильное приложение</div>-->
                        <div class="grid justify-content-center text-center text-color-white">
                          <a href="/app/ios/skauto" target="_blank" class="grid__cell">
                            <img class="screen__illustration" src="../assets/img/content/appstore.svg" alt="iPhone и iPad">
                            <div class="l-title ">iPhone и iPad</div>
                          </a>
                          <a href="https://play.google.com/store/apps/details?id=megaf.auto" target="_blank" class="grid__cell">
                            <img class="screen__illustration store-logo" src="../assets/img/content/googleplay.svg" alt="Android">
                            <div class="l-title">Android</div>
                          </a>
                          <a v-on:click="isActiveOverlayLoginToggle()" target="_blank" class="grid__cell">
                            <img class="screen__illustration" src="../assets/img/content/webapp.svg" alt="Вход в систему">
                            <div class="l-title">Вход в систему</div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </perfect-scrollbar>
        </swiper-slide>
        <!-- Mobicar Pro -->
        <swiper-slide class="swiper-slide mainSwiperInitial_item">
          <perfect-scrollbar>
            <div class="mobicarPro-initial" id="dst-m3pro">
              <div class="centered">
                <div class="screen__title">Mobicar 3 PRO</div>
                <div class="mobicarPro_description">Управление охранной системой через интернет</div>
                <div class="mobicarPro_briefly">
                  <div class="mobicarPro_briefly-cnt">
                    <ul class="mobicarPro_base-list">
                      <li>На любом расстоянии в зоне действия сотовой связи</li>
                      <li>Дешевле, чем телефонный звонок</li>
                      <li>Выполнение команд онлайн</li>
                    </ul>
                    <div class="mobicarPro-initial_buy"
                         v-on:click="getMobicarPro()">
                      <img src="../assets/img/content/mobicarPro/buy.png">
                    </div>
                  </div>
                </div>
                <div class="mobicarPro_details">
                  <div class="mobicarPro_details-text">
                    <div class="mobicarPro_details-title">
                      Автомобиль всегда под вашим присмотром
                    </div>
                    <ul class="mobicarPro_details-list">
                      <li>Данные панели приборов**</li>
                      <li>Открыты или закрыты двери, капот и багажник</li>
                      <li>Состояние охранной системы: включен ли режим охраны, были ли  тревожные события</li>
                      <li>Маршрут движения и местоположение автомобиля с точностью до километра</li>
                      <li>Статистика использования автомобиля</li>
                      <li>Push-оповещения от охранного устройства</li>
                    </ul>
                  </div>
                  <div class="mobicarPro_phone-example">
                    <div class="mobicarPro_listParam">
                      <img src="../assets/img/content/mobicarPro/listParam.png">
                    </div>
                    <img class="mobicarPro_phone-example-img" src="../assets/img/content/mobicarPro/phone2.png" width="287">
                  </div>
                </div>
              </div>
              <div class="mobicarPro_status">
                <div class="centered">
                  <div class="mobicarPro_status-icons">
                    <img :src="img" v-for="img in mobicarPro.listStastus">
                  </div>
                  <div class="mobicarPro_status-note">
                    *  - состав данных может различаться в зависимости от модели автомобиля,<br>
                    ** - при включенном зажигании, доступность зависит от модели автомобиля
                  </div>
                </div>
              </div>
            </div>
          </perfect-scrollbar>
        </swiper-slide>
        <!-- FAQ документация -->
        <swiper-slide class="swiper-slide mainSwiperInitial_item">
          <div class="faq">
            <div class="faq-cnt"
                 v-bind:class="{ 'faq-cnt__hiden' : scrollBar.faq }">
              <div class="d-flex flex-column justify-content-between min-height-100">
                <div class="centered flex-fill d-flex flex-column justify-content-center">
                  <div class="grid">
                    <div class="grid__cell-lg-20 offset-lg-2">
                      <div class="screen screen--docs">
                        <div class="grid">
                          <div class="grid__cell-24">
                            <div class="screen__text">Часто задаваемые вопросы</div>
                            <div class="list">
                              <div class="list__item">
                                Какова точность определения местоположения комплексов Scher-Khan Universe?
                                <div class="help-block">Два с половиной метра. Навигационный приемник в Universe использует сигналы GPS и ГЛОНАСС одновременно, что особенно полезно в условиях городской застройки.</div>
                              </div>
                              <div class="list__item">
                                Отличается ли управление и настройка комплекса Scher-Khan Universe от управления и настройки двусторонней сигнализации? Справится ли человек, далекий от техники?
                                <div class="help-block">Отличается, и в лучшую сторону: большинству пользователей вообще не придется что-либо настраивать, достаточно зарегистрировать номер телефона, и комплекс готов к работе.</div>
                              </div>
                              <div class="list__item">
                                Есть ли необходимость при установке Scher-Khan Universe оснащать автомобиль еще какими-либо дополнительными охранными устройствами?
                                <div class="help-block">
                                  Одно из преимуществ комплекса заключается в том, что он позволяет полностью защитить автомобиль от угона без дополнительных охранных устройств. Причем степень защиты можно наращивать: в базовых моделях доступны три способа проводной блокировки двигателя, а в старших моделях семейства к ним добавляются беспроводные иммобилайзеры с управлением по радио.
                                </div>
                              </div>
                              <div class="list__item">
                                Есть ли экономическая выгода в приобретении телематического комплекса Scher-Khan Universe по сравнению с покупкой отдельных элементов (спутниковая система позиционирования, двусторонняя сигнализация, иммобилайзер и т.д.)?
                                <div class="help-block">
                                  Есть, и существенная! Комплексное решение не только дешевле, но и эффективнее – в случае Scher-Khan Universe входящие в его состав модули синхронизируют свою работу, обмениваясь данными по радио.
                                </div>
                              </div>
                              <div class="list__item">
                                Имеет ли значение, SIM-карту какого оператора выбрать?
                                <div class="help-block">
                                  В комплект входит SIM-карта с тарифным планом, который разработан специально для использования с комплексом Scher-Khan Universe. Ограничений на использование SIM-карт других операторов нет.
                                </div>
                              </div>
                              <div class="list__item">
                                Есть ли какие-то ограничения при продаже автомобиля с установленным на нем телематическим комплексом Scher-Khan Universe? Нужно ли его обязательно демонтировать? Будет ли доступна «история» моего автомобиля после его продажи другому владельцу?
                                <div class="help-block">
                                  Важный вопрос, так как на серверах содержится история поездок и другая личная информация. Мы предусмотрели простую процедуру стирания всей личной информации при продаже автомобиля. Это можно сделать при удалении автомобиля из личного кабинета.
                                </div>
                              </div>
                              <div class="list__item">
                                Насколько точны данные по автомобильному расходу топлива, отображающиеся в личном кабинете на тематическом портале?
                                <div class="help-block">
                                  Без подключения дополнительных датчиков точность соответствует точности индикатора на панели приборов вашего автомобиля (при условии выполнения процедуры калибровки).
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="faq-showmore"
                   v-bind:class="{ 'faq-showmore__hiden' : scrollBar.showMore }">
                <div class="faq-showmore_text"
                     v-on:click="faqShowMore">
                  развернуть
                </div>
              </div>
            </div>
            <div class="faq-cnt"
                 v-bind:class="{ 'faq-cnt__hiden' : !scrollBar.faq }">
              <perfect-scrollbar>
                <div class="d-flex flex-column justify-content-between min-height-100">
                  <div class="centered flex-fill d-flex flex-column justify-content-center">
                    <div class="grid">
                      <div class="grid__cell-lg-20 offset-lg-2">
                        <div class="screen screen--docs">
                          <div class="grid">
                            <div class="grid__cell-24" id="dst-faq">
                              <div class="screen__text">Часто задаваемые вопросы</div>
                              <div class="list">
                                <div class="list__item">
                                  Какова точность определения местоположения комплексов Scher-Khan Universe?
                                  <div class="help-block">Два с половиной метра. Навигационный приемник в Universe использует сигналы GPS и ГЛОНАСС одновременно, что особенно полезно в условиях городской застройки.</div>
                                </div>
                                <div class="list__item">
                                  Отличается ли управление и настройка комплекса Scher-Khan Universe от управления и настройки двусторонней сигнализации? Справится ли человек, далекий от техники?
                                  <div class="help-block">Отличается, и в лучшую сторону: большинству пользователей вообще не придется что-либо настраивать, достаточно зарегистрировать номер телефона, и комплекс готов к работе.</div>
                                </div>
                                <div class="list__item">
                                  Есть ли необходимость при установке Scher-Khan Universe оснащать автомобиль еще какими-либо дополнительными охранными устройствами?
                                  <div class="help-block">
                                    Одно из преимуществ комплекса заключается в том, что он позволяет полностью защитить автомобиль от угона без дополнительных охранных устройств. Причем степень защиты можно наращивать: в базовых моделях доступны три способа проводной блокировки двигателя, а в старших моделях семейства к ним добавляются беспроводные иммобилайзеры с управлением по радио.
                                  </div>
                                </div>
                                <div class="list__item">
                                  Есть ли экономическая выгода в приобретении телематического комплекса Scher-Khan Universe по сравнению с покупкой отдельных элементов (спутниковая система позиционирования, двусторонняя сигнализация, иммобилайзер и т.д.)?
                                  <div class="help-block">
                                    Есть, и существенная! Комплексное решение не только дешевле, но и эффективнее – в случае Scher-Khan Universe входящие в его состав модули синхронизируют свою работу, обмениваясь данными по радио.
                                  </div>
                                </div>
                                <div class="list__item">
                                  Имеет ли значение, SIM-карту какого оператора выбрать?
                                  <div class="help-block">
                                    В комплект входит SIM-карта с тарифным планом, который разработан специально для использования с комплексом Scher-Khan Universe. Ограничений на использование SIM-карт других операторов нет.
                                  </div>
                                </div>
                                <div class="list__item">
                                  Есть ли какие-то ограничения при продаже автомобиля с установленным на нем телематическим комплексом Scher-Khan Universe? Нужно ли его обязательно демонтировать? Будет ли доступна «история» моего автомобиля после его продажи другому владельцу?
                                  <div class="help-block">
                                    Важный вопрос, так как на серверах содержится история поездок и другая личная информация. Мы предусмотрели простую процедуру стирания всей личной информации при продаже автомобиля. Это можно сделать при удалении автомобиля из личного кабинета.
                                  </div>
                                </div>
                                <div class="list__item">
                                  Насколько точны данные по автомобильному расходу топлива, отображающиеся в личном кабинете на тематическом портале?
                                  <div class="help-block">
                                    Без подключения дополнительных датчиков точность соответствует точности индикатора на панели приборов вашего автомобиля (при условии выполнения процедуры калибровки).
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </perfect-scrollbar>
            </div>
          </div>
        </swiper-slide>
        <!-- О компании -->
        <swiper-slide class="swiper-slide mainSwiperInitial_item">
          <perfect-scrollbar>
            <div class="initial-about" id="dst-about">
              <div class="centered">
                <div class="screen__title">
                  О компании
                </div>
                <p class="screen__text-medium">
                  «Мега-Ф» – лидер российского рынка автомобильного охранного оборудования. Более двух десятков лет компания разрабатывает охранные системы и аксессуары для автомобилей. Свою деятельность компания начала в 1995 году.
                </p>
              </div>
              <div class="about-history">
                <swiper :options="swiper.aboutHistory">
                  <swiper-slide
                      v-for="(item, index) in about.history"
                      class="about-history_item"
                      v-bind:key="index">
                    <div class="about-history_year">
                      {{item.year}}
                    </div>
                    <div class="about-history_timeline">
                      <div class="about-history_timeline-point">
                      </div>
                      <div class="about-history_timeline-arrow">
                      </div>
                    </div>
                    <div class="about-history_text">
                      {{item.text}}
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <div class="centered">
                <p class="screen__text-medium">
                  К настоящему моменту торговая марка SCHER-KHAN является самой узнаваемой на российском рынке автосигнализаций и предлагает покупателям широкий ассортимент устройств среднего и высшего класса, которые созданы с учетом последних тенденций в мировой автомобильной электронике.
                </p>
              </div>
            </div>
          </perfect-scrollbar>
        </swiper-slide>
        <!-- Контакты -->
        <swiper-slide class="swiper-slide mainSwiperInitial_item">
          <swiper ref="contactsScroll"
                  :options="{
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    freeMode: true,
                    allowTouchMove :false,
                    mousewheel: true
                  }"
                  @fromEdge="edgeContacts"
                  @reachBeginning="blurCities"
                  >
            <swiper-slide class="swiper-slide">
              <div class="initial-contacts" id="dst-contacts">
                <div class="centered">
                  <div class="screen__title">
                    Контакты
                  </div>
                  <div class="contacts-countries">
                    <div v-for="(country, countryIndex) in contacts.countries"
                         v-bind:key="countryIndex"
                         class="contacts-countries_item">
                      <span class="contacts-countries_name"
                            v-on:click="selectCountry(countryIndex)"
                            v-bind:class="{ 'contacts-countries_item__active' : contacts.current.country === countryIndex }"  >{{country.title}}</span>
                    </div>
                  </div>
                  <div class="cities">
                    <div class="cities-cnt">
                      <div class="cities_select"
                          v-if="contacts.current.country === 0">
                        <cool-select v-model="contacts.current.city"
                                   :items="contacts.countries[0].cities"
                                   value="contacts.countries[0].cities[0]"
                                   item-text="city"
                                   @focus="focusCities()"
                                   @blur="blurCities()"
                                   @select="blurCities()"
                                   ref="SelecCities"
                                   menuItemsMaxHeight="160px">
                      </cool-select>
                      </div>
                      <div class="cities_card" v-if="contacts.current.city">
                        <div class="cities_title">
                          {{contacts.current.city.title}}
                        </div>
                        <div class="cities_field"
                             v-for="(field, indexField) in contacts.current.city.info"
                             v-bind:key="indexField">
                          <div class="cities_field-name">
                            {{field.name}}
                          </div>
                          <div class="cities_field-value">
                            <a :href="'mailto:' + field.value" v-if="field.name === 'E-mail'">{{field.value}}</a>
                            <span v-else>{{field.value}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="cities-cnt">
                      <div class="contacts-map"
                           @mouseover="blurMap"
                           @mouseleave="focusMap">
                        <l-map
                            id="osm-map"
                            :zoom="contacts.zoom"
                            :center="contacts.center"
                            :options="contacts.mapOptions"
                            ref="map"
                        >
                          <l-tile-layer
                              :url="contacts.url"
                              :attribution="contacts.attribution"
                          />
                        </l-map>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer></Footer>
              <div class="swiper-scrollbar"></div>
            </swiper-slide>
          </swiper>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination">
        </div>
      </swiper>
    </div>
    <!--  ЭКРАНЫ END -->
  </div>
</template>

<script>
  import Header from '@/components/Initial/Header.vue'
  import Footer from '@/components/Initial/Footer.vue'

  import { HTTP_COMM } from '@/main'

  // Lib - Components
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  // Lib - CSS
  import 'swiper/dist/css/swiper.css'

  // CSS
  import "../style/libs/bootstrap-less-port/less/bootstrap-grid.less";
  import '../style/libs/swiper.less'

  // CoolSelect
  import { CoolSelect } from 'vue-cool-select'

  import { latLng, icon } from "leaflet";
  import { LMap, LTileLayer } from 'vue2-leaflet';
  import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker';
  import 'leaflet/dist/leaflet.css';

  export default {
    name: "initial-page",
    data() {
      return {
        swiper : {
          fullpageOptions : {
            direction: 'vertical',
            mousewheel: true,
            allowTouchMove :false,
            speed: 700,
            pagination: {
              el: '.swiper-pagination',
              clickable: true
            },
            breakpoints: {
              1024: {
                freeMode : true,
                pagination: false,
                allowTouchMove :true,
              }
            },
            keyboard: {
              enabled: true,
            },
          },
          aboutHistory : {
            direction: 'horizontal',
            mousewheel: false,
            slidesPerView: 4,
            centeredSlides: true,
            grabCursor: true,
            breakpoints: {
              1200: {
                slidesPerView: 3,
              },
              1024:{
                slidesPerView: 2,
                autoHeight: true
              },
              700 : {
                slidesPerView: 1,
              }
            },
          },
          functionsOptions: {
            direction: 'horizontal',
            slidesPerView: 4,
            spaceBetween: 30,
            freeMode: true,
            grabCursor: true,
            scrollbar: {
              el: '.swiper-scrollbar',
              draggable: true,
            },
            breakpoints: {
              768: {
                slidesPerView: 2
              },
              576: {
                slidesPerView: 1
              }
            }
          },
        },
        activeOfferSlide: 0,
        window: {
          width: 0,
          height: 0
        },

        scrollBar : {
          showMore : false,
          faq : false,
        },
        documents : [],
        about : {
          history : [
            {
              year : '1995',
              text : '«Мега-Ф» предложила пользователям свою первую автосигнализацию, которая, как и все подобные устройства в России на тот момент, была односторонней.'
            },
            {
              year : '1998',
              text : '«Мега-Ф» вывела на рынок революционную охранную систему, во многом определившую последующее развитие автосигнализаций как охранного оборудования. Это была модель SCHER-KHAN MAGICAR, впервые в России предоставившая автовладельцам двустороннюю связь и брелок-коммуникатор с ЖК-дисплеем.Ш'
            },
            {
              year : '2000',
              text : 'В 2000-х годах «Мега-Ф» расширила ассортимент охранного оборудования и автоаксессуаров. Были разработаны и поступили в продажу GSM-модули, иммобилайзеры, замки капота, компрессоры и другие устройства. Рост компании ознаменовался расширением географии ее присутствия – сегодня офисы собственных региональных компаний и торговых представительств располагаются более чем в 40 городах России, Украины, Казахстана и других стран СНГ.'
            },
            {
              year : '2004',
              text : 'Продукция компания «Мега-Ф» получила признание у иностранных производителей автомобилей. Охранные системы торговых марок SCHER-KHAN и PHARAON были авторизованы российскими представительствами Форд Соллерс, Фольксваген, Ниссан, Опель, Шевроле, Киа, Хендай, Рено, Ситроен, Пежо, Мазда, Мицубиси. Устройства и аксессуары Мега-Ф включены в каталоги оригинальной продукции и рекомендованы к установке в дилерских салонах соответствующих марок автомобилей.'
            },
            {
              year : '2010',
              text : '«Мега-Ф» приступила к разработке телематических комплексов на основе ГЛОНАСС.'
            },
            {
              year : '2012',
              text : 'Развернут собственный сервер хранения и отображения маршрутов движения транспортных средств и сопутствующих телематических данных. Вниманию общественности также был предложен модельный ряд телематических комплексов Scher-Khan Universe, каждый их которых представляет комплексное решение для транспортных средств по обеспечению позиционирования на местности, флит-менеджмента (управления автопарком), безопасности и прочих задач.'
            },
            {
              year : '2013',
              text : 'Тестирование телематических комплексов SCHER-KHAN UNIVERSE в различных условиях и на различных автомобилях. Продукция SCHER-KHAN UNIVERSE была представлена на международной выставке «Навитех-2013».'
            },
            {
              year : '2014',
              text : 'Российский союз автостраховщиков включил телематическую охранную систему SCHER-KHAN UNIVERSE в базу операторов спутниковых мониторинговых систем, которые могут быть использованы при упрощённом оформлении ДТП без участия полиции по процедуре Европротокола. Компания «Мега-Ф» представила новейшие разработки – SCHER-KHAN UNIVERSE 1 и SCHER-KHAN UNIVERSE 2 и UNIVERSE 3.'
            },
            {
              year : '2016',
              text : 'В продажу поступила охранная система нового поколения: Scher-Khan Mobicar 1. В новинке реализован запуск двигателя, не требующий наличия в автомобиле запасного ключа (бесключевой обходчик иммобилайзера).'
            },
            {
              year : '2017',
              text : 'Новая охранная система Scher-Khan Mobicar 2 появилась в продаже. Для управления и настройки системы теперь служит смартфон, подключенный к системе через Bluetooth.'
            },
            {
              year : '2019',
              text : 'Готовится к выпуску охранная GSM-система Scher-Khan Mobicar 3. Управление системой и информирование теперь не ограничены дальностью работы брелока.'
            },
          ]
        },
        contacts : {
          zoom: 13,
          center: latLng(55.6507838, 37.441247),
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          currentZoom: 11.5,
          currentCenter: latLng(55.6507838, 37.441247),
          showParagraph: false,
          mapOptions: {
            zoomSnap: 0.5,
            zoomControl: false
          },
          iconMarker : icon({
            iconUrl: require('../assets/img/map/stop-main.png'),
            rotationAngle: 45
          }),
          map: {
            center : {
              lat : 55.6507838,
              lng : 37.441247
            },
            options : {
              disableDefaultUI : true,
              gestureHandling: 'greedy'
            },
            zoom : 12,
            marker : ''
          },
          attribution:
              '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          current : {
            country : 0,
            city : '',
          },
          countries : [
            {
              name    : "russia",
              title   : "Россия",
              cities  : [
                {
                  city  : 'Москва',
                  title : '«Мега-Ф» Москва. Центральный офис',
                  lat   : '55.652542',
                  lng   : '37.441112',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'МО, Ленинский р-н, дер. Говорово, 47 км МКАД '
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (495) 649-71-73'
                    },
                    {
                      'name'  : 'Факс',
                      'value' : '+7 (495) 649-71-74'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'info@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Волгоград',
                  title : '«Мега-Ф» Волгоград',
                  lat   : '48.744787',
                  lng   : '44.500320',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'бул. 30-летия Победы, д. 19а'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (8442) 48-28-49, 48-28-53'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (961) 062-08-28'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'volgograd@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Воронеж',
                  title : '«Мега-Ф» Воронеж',
                  lat   : '51.657210',
                  lng   : '39.174943',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Бахметьева, д. 1, оф. 20'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (4732) 33-25-73, 33-25-74'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : ' +7 (915) 542-13-02'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'voronezh@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Екатеринбург',
                  title : '«Мега-Ф» Екатеринбург',
                  lat   : '56.820035',
                  lng   : '60.652227',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Сибирский тракт, д. 12, стр. 8, оф. 409'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (343) 288-53-41'
                    },
                    {
                      'name'  : 'Факс',
                      'value' : '+7 (343) 379-47-01'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'ekaterinburg@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Казань',
                  title : '«Мега-Ф» Казань',
                  lat   : '55.787563',
                  lng   : '49.180058',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Седова, д. 24, оф. 41'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (843) 273-46-48, 272-76-71, 272-97-76'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (919) 616-75-74'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (917) 804-44-53'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (917) 797-31-11'
                    },
                    {
                      'name'  : 'Факс',
                      'value' : '+7 (843) 273-46-48'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'kazan@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Калининград',
                  title : '«Мега-Ф» Калининград',
                  lat   : '54.747709',
                  lng   : '20.566183',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'Калининградская обл., Гурьевский район, п. Невское, ул. Индустриальная, д. 1'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (4012) 59-80-08'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (906) 230-40-47'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (9622) 62-00-62'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'kaliningrad@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Краснодар',
                  title : '«Мега-Ф» Краснодар',
                  lat   : '45.069414',
                  lng   : '38.979775',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Лузана, д. 19, литер А, оф. 119'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (861) 224-57-75'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (988) 52-97-394'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (918) 486-46-06'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'krasnodar@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Красноярск',
                  title : '«Мега-Ф» Красноярск',
                  lat   : '56.003105',
                  lng   : '92.847424',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Дубровинского, д. 112, оф. 310'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (391) 258-19-34'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (391) 258-19-35'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (933) 331-68-67'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'krasnoyarsk@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Нижний Новгород',
                  title : '«Мега-Ф» Нижний Новгород',
                  lat   : '56.301229',
                  lng   : '44.077708',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Родионова, д. 197, корп. 2, оф. 5'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (831) 438-49-36'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (910) 101-44-15'
                    },
                    {
                      'name'  : 'Факс',
                      'value' : '+7 (831) 438-42-66'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'n.novgorod@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Новосибирск',
                  title : '«Мега-Ф» Новосибирск',
                  lat   : '54.998007',
                  lng   : '82.822054',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Станционная 60/10, офис 305'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (383) 319-13-15'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (383) 319-13-14'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (913) 913-40-43'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (903) 934-53-22'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'novosibirsk@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Омск',
                  title : '«Мега-Ф» Омск',
                  lat   : '54.987620',
                  lng   : '73.389398',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'Омская улица, 22/18'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (908) 108-18-09'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'omsk@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Пермь',
                  title : '«Мега-Ф» Пермь',
                  lat   : '58.010372',
                  lng   : '56.201201',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Монастырская, д. 144'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (342) 240-37-80'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (342) 240-37-81'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'perm@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Ростов-на-Дону',
                  title : '«Мега-Ф» Ростов-на-Дону',
                  lat   : '47.253975',
                  lng   : '39.795522',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'просп. Шолохова, д. 258/1'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (863) 252-44-51'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (863) 250-86-71'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (960) 459-97-20'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7(960) 459-97-40'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'rostov_don@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Самара',
                  title : '«Мега-Ф» Самара',
                  lat   : '53.306760',
                  lng   : '50.291233',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'п. Мехзавод, Московское шоссе, 20 км, строение 75, оф. 315'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (846) 231-53-53'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (987) 979-16-88'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'samara@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Санкт-Петербург',
                  title : '«Мега-Ф» Санкт-Петербург',
                  lat   : '59.883273',
                  lng   : '30.339869',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'пр. Люботинский, д. 5'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (812) 388-00-81'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (812) 388-00-83'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'spb@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Ставрополь',
                  title : '«Мега-Ф» Ставрополь',
                  lat   : '45.039383',
                  lng   : '41.904015',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Ленина, д. 482б'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (8652) 56-58-69, 56-61-47'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7(906) 489-99-11'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'stavropol@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Тюмень',
                  title : '«Мега-Ф» Тюмень',
                  lat   : '57.126353',
                  lng   : '65.521509',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Баумана, д. 29, оф. 704 А (офис/склад)'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : ' +7 (3452) 500-951, 500-952'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (905) 824-02-23'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (922) 470-18-28'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'tmn@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Уфа',
                  title : '«Мега-Ф» Уфа',
                  lat   : '54.768297',
                  lng   : '56.015601',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Р. Зорге, д. 70/1, офис 4'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (347) 244-80-86, 244-80-79'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (919) 616-75-74, 804-44-53, 797-31-11'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (960) 030-02-60'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (903) 305-42-90'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'ufa@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Челябинск',
                  title : '«Мега-Ф» Челябинск',
                  lat   : '55.188031',
                  lng   : '61.377417',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул Островского, д. 30'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (351) 225-41-30'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'chelyabinsk@mega-f.ru'
                    },
                  ]
                },
                {
                  city  : 'Ярославль',
                  title : '«Мега-Ф» Ярославль',
                  lat   : '57.634029',
                  lng   : '39.888191',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'ул. Терешковой, д. 7'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (4852) 30-22-85, 32-80-72'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'yaroslavl@mega-f.ru'
                    },
                  ]
                },
              ]
            },
            {
              name    : "belorussia",
              title   : "Белоруссия",
              cities  : [
                {
                  city  : 'Минск',
                  title : '«Мега-Ф» Белоруссия',
                  lat   : '53.918840',
                  lng   : '27.505564',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'г. Минск, ул. Ольшевского, д. 18, к. 2'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (812) 388-00-81, 388-00-83 '
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'pavel_layada@mail.ru'
                    },
                  ]
                },
              ]
            },
            {
              name    : "kazakhstan",
              title   : "Казахстан",
              cities  : [
                {
                  city  : 'Алматы',
                  title : '«Мега-Ф» Казахстан',
                  lat   : '43.256165',
                  lng   : '76.932205',
                  info  : [
                    {
                      'name'  : 'Адрес',
                      'value' : 'г. Алматы, пр. Сейфуллина, д. 531, БЦ САРЫАРКА оф. 501'
                    },
                    {
                      'name'  : 'Телефон',
                      'value' : '+7 (727) 272-20-82, 272-20-66'
                    },
                    {
                      'name'  : 'E-mail',
                      'value' : 'astana@mega-f.ru'
                    },
                  ]
                },
              ]
            }
          ],
          markers : []
        },
        mobicarPro : {
          listParam : [
            require('../assets/img/content/mobicarPro/st1.svg'),
            require('../assets/img/content/mobicarPro/st2.svg'),
            require('../assets/img/content/mobicarPro/st3.svg'),
            require('../assets/img/content/mobicarPro/st4.svg'),
            require('../assets/img/content/mobicarPro/st5.svg'),
            require('../assets/img/content/mobicarPro/st6.svg'),
            require('../assets/img/content/mobicarPro/st7.svg'),
            require('../assets/img/content/mobicarPro/st8.svg'),
            require('../assets/img/content/mobicarPro/st9.svg'),
          ],
          listStastus : [
            require('../assets/img/content/mobicarPro/ic01.svg'),
            require('../assets/img/content/mobicarPro/ic02.svg'),
            require('../assets/img/content/mobicarPro/ic03.svg'),
            require('../assets/img/content/mobicarPro/ic04.svg'),
            require('../assets/img/content/mobicarPro/ic05.svg'),
            require('../assets/img/content/mobicarPro/ic06.svg'),
            require('../assets/img/content/mobicarPro/ic07.svg'),
            require('../assets/img/content/mobicarPro/ic08.svg'),
            require('../assets/img/content/mobicarPro/ic09.svg'),
            require('../assets/img/content/mobicarPro/ic10.svg'),
            require('../assets/img/content/mobicarPro/ic11.svg'),
            require('../assets/img/content/mobicarPro/ic12.svg'),
            require('../assets/img/content/mobicarPro/ic13.svg'),
            require('../assets/img/content/mobicarPro/ic14.svg'),
            require('../assets/img/content/mobicarPro/ic15.svg'),
            require('../assets/img/content/mobicarPro/ic16.svg'),
          ]
        }
      }
    },
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    mounted(){
      setTimeout( () => {
        this.contacts.current.city = this.contacts.countries[0].cities[0];

        HTTP_COMM.get('/content/v1/documents/')
          .then( response => {
            for( let i = 0; i < response.data.results.length; i++ ){
              this.documents.push( response.data.results[i] );
            }
          })
          .catch( error => {
            this.$store.dispatch('errorResponse', error );
          });

        document.getElementsByClassName('page')[0].focus();
        document.getElementsByClassName('page')[0].addEventListener('keyup', (e) => {
          if (e.keyCode === 36) {
            this.goToSlide(0)
          }else if( e.keyCode === 35 ){
            this.goToSlide(5)
          }
        });

      }, 500);

      if( window.location.search.indexOf('confirm=password') !== -1 ){
          this.isActiveOverlayLoginToggle()
      }
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize);
    },
    computed : {
      initialData : function (){
        return this.$store.state.initial
      },
      isAuthorized() {
        return this.$store.state.user.isAuthorized;
      },
      initialPage() {
        return this.$store.state.initialPage;
      },
      isActiveOverlayLogin(){
        return this.$store.state.panels.login.status
      },
      remind(){
        return this.$store.state.panels.login.remind
      }
    },
    methods: {
      onLeave () {
        this.activeOfferSlide = 0;
      },
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;

        if( this.$refs.MainSwiper ){
          if (this.window.width <= 1024 ) {
            this.$refs.MainSwiper.swiper.pagination.destroy();
          } else {
            this.$refs.MainSwiper.swiper.pagination.init();
            this.$refs.MainSwiper.swiper.pagination.update();
          }
        }
      },
      toggleInitialPage () {
        this.$store.dispatch('toggleInitialPage');
      },

      toggleLoginPanel(){
        this.$store.dispatch('toggleLoginPanel');
      },
      isActiveOverlayLoginToggle(){
        this.$store.dispatch('toggleLoginPanel');
      },

      // Выбор страны в контактах
      selectCountry( index ) {
        this.contacts.current.country = index;
        this.contacts.current.city = this.contacts.countries[index].cities[0];
      },
      // Включение/отключение скролла при выборе города
      focusCities(){
        this.$refs.MainSwiper.swiper.mousewheel.disable()
      },
      blurCities(){
        this.$refs.MainSwiper.swiper.mousewheel.enable()
      },

      // Скролл в контактах
      edgeContacts(){
        if( this.$refs.MainSwiper.swiper.activeIndex === 5 ){
          this.focusCities();
        }
      },
      blurMap(){
        this.$refs.contactsScroll.swiper.mousewheel.disable();
        this.$refs.MainSwiper.swiper.mousewheel.disable();
        console.log('blur')
      },
      focusMap(){
        this.$refs.contactsScroll.swiper.mousewheel.enable();
        this.$refs.MainSwiper.swiper.mousewheel.enable();
        console.log('focus')
      },

      // Перейти к слайду
      goToSlide( index, speed ){
        if( speed === 'fast' ){
          this.$refs.MainSwiper.swiper.slideTo( index, 0 );
				}else{
          this.$refs.MainSwiper.swiper.slideTo( index );
        }
      },

      // Faq show more
      faqShowMore(){
        this.scrollBar.showMore = true;
        setTimeout(()=>{
          this.scrollBar.faq = true
        }, 500);
      },

      // Get MobicarPro
      getMobicarPro(){
        if( !this.isAuthorized ){
          this.toggleLoginPanel();
        }else{
          this.toggleInitialPage();
          this.$store.dispatch('initialGetMobicarPro');
        }
      },

			// Проверяем нужен ли  переход к конкретному слайду
      checkFullpageSlideTo(){
        let dstParam,
        	  remData = this.remind;

        if( remData !== '' ){
          dstParam  = remData.dst;
				}else{
          if( this.remind && this.remind.dst ){
            dstParam = this.remind.dst
					}
				}

        if( dstParam ){ // this.remind.dst
          if( document.getElementsByTagName('body')[0].offsetWidth > 1024 ){
						switch( dstParam ) {
							case 'about':
								this.goToSlide(5, 'fast');
								break;
							case 'contacts':
								this.goToSlide(6, 'fast');
								break;
							case 'documentation':
                window.location.href = '/docs'
								break;
							case 'faq':
								this.goToSlide(4, 'fast');
								break;
							case 'm3pro':
								this.goToSlide(3, 'fast');
								break;
							default:
								break;
						}
          }else{
            setTimeout(() => {
              let a = document.getElementsByClassName('mainSwiperInitial_item');
              switch( dstParam ) {
                case 'about':
                  window.scrollTo(0, a[5].offsetTop);
                  break;
                case 'contacts':
                  window.scrollTo(0, a[6].offsetTop);
                  break;
                case 'documentation':
                  window.location.href = '/docs'
                  break;
                case 'faq':
                  window.scrollTo(0, a[4].offsetTop);
                  break;
                case 'm3pro':
                  window.scrollTo(0, a[3].offsetTop);
                  break;
                default:
                  break;
              }
						}, 1000);
					}
        }
			}

    },
    watch: {
      'contacts.current.city' : function ( curCity ) {
        if( curCity ){
          const L = window.L;
          const map = this.$refs.map.mapObject;

          if( this.contacts.markers.length ){
            for( let i = 0; i < this.contacts.markers.length; i++ ){
              map.removeLayer(this.contacts.markers[i]);
            }
            this.contacts.markers = [];        }


          map.setView(new L.LatLng(parseFloat(curCity.lat), parseFloat(curCity.lng)), 14);

          let marker = new L.marker(
              [curCity.lat, curCity.lng],
              {
                icon : L.icon({
                  iconUrl: require('../assets/img/map/point.png'),
                  iconSize: [40, 43],
                }),
                draggable : false
              }
          );

          this.contacts.markers.push( marker );
          map.addLayer(marker);
        }
      },
      'initialData.slideTo' :  function ( curData ){
        this.goToSlide( curData.index, curData.speed );
      }
    },
    components: {
      swiper,
      swiperSlide,
      CoolSelect,
      Header,
      Footer,
      LMap,
      LTileLayer,
      'v-rotated-marker': Vue2LeafletRotatedMarker
    },
  }
</script>
